import React from 'react';
import { TextGenerateEffect } from '../../components/ui/text-generate-effect';
import { BackgroundBeams } from '../../components/ui/background-beams';
import {
  Search, BadgeIndianRupee, CirclePercent, Store, DraftingCompass, Globe, Microchip,
  User, ShieldOff,
  ShoppingCart,
  Smartphone,
  Monitor,
  Tablet,
  Rocket,
  Glasses,
  Paintbrush,
  Rotate3D,
  ArrowBigRight,
  Megaphone,
  Award,
  BotMessageSquare,
  ChartCandlestick,
  ShoppingBag,
  CodeXml,
  Tag,
  ChartPie,
  Bot, CircleCheckBig
} from 'lucide-react';
import Layout from '../../components/layout';
import { Link } from 'react-router-dom';
import { FaStore, FaTag, FaGlobe, FaChartPie, FaShoppingCart, FaSearch, FaChartLine, FaTools, FaBullseye, FaBullhorn, FaHandshake } from 'react-icons/fa'
import { IoRocketSharp } from "react-icons/io5";
import { FaWhatsapp, FaComments, FaCogs } from 'react-icons/fa';
import { MdWidgets } from 'react-icons/md';
import { MdPhoneIphone, MdAndroid } from 'react-icons/md';
// import { BackgroundBeamsWithCollision } from "@/components/ui/background-beams-with-collision";
import { BackgroundBeamsWithCollision } from '../../components/ui/background-beams-with-collision';
import "./zclik.css"
import { color } from 'framer-motion';

// import { FaChartLine } from 'react-icons/fa';


const ZeroClick = () => {
  return (
    <Layout>
      <div className="bg-white text-gray-800 font-sans min-h-screen">
        <BackgroundBeamsWithCollisionDemo />
        {/* <Hero /> */}
        <WhyZeroClick2 />
        {/* <WhyZeroClick /> */}
        <MarketPlace />
        <CoreModulesCapabilities />
        <Features />

        <TableUI />
        {/* <ARShowcase /> */}
        <Ui />
        {/* <Personalization />
        <ONDCIntegration />
        <CrossDevice /> */}
        {/* <Benefits /> */}
        {/* <UseCases /> */}
        {/* <RequestDemo /> */}
      </div>
    </Layout>
  );
};

export default ZeroClick;

const Hero = () => (
  <>
    <section className="flex items-center justify-center min-h-screen bg-gradient-to-br from-blue-600 to-indigo-700 text-white pb-20">
      <div className="text-center max-w-4xl mx-auto px-6">
        <h1 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight"> 0clik , A Digital Commerce That  Launch Instantly!</h1>
        <p className="text-xl md:text-2xl mb-6 max-w-2xl mx-auto leading-relaxed">
          Launch a Business in Minutes, Run it Like an Enterprise.

        </p>
        <p className="text-xl md:text-1xl mb-6 max-w-2xl mx-auto leading-relaxed">
          One Platform | Zero Code | Infinite Growth
        </p>

        {/* <p className=" mb-6 max-w-2xl mx-auto leading-relaxed">
        AI-Native Website & App Stack for Digital-First Brands, Aspiring Enterprises, and E-Commerce Marketplaces
        0Clik is a one-click, no-code platform to build, deploy, and run an intelligent digital commerce experience with Gen-AI chatbot, Gen-AI search, recommendation engine, innovative pricing, and more.

      </p> */}
        <a
          target='_blank'
          href="https://0clik.com/"
          className="inline-flex items-center px-8 py-4 bg-white text-blue-600 font-semibold rounded-full shadow-lg hover:bg-gray-100 transition duration-300 text-lg"
        >
          <Rocket className="mr-2 h-6 w-6" /> Try Now
        </a>
      </div>
    </section>




  </>


);



export function BackgroundBeamsWithCollisionDemo() {
  return (
    <BackgroundBeamsWithCollision>
      <h2
        className="text-2xl relative z-20 md:text-4xl lg:text-7xl font-bold text-center text-black dark:text-white font-sans tracking-tight">
        0clik , A Digital Commerce !
        <div
          className="relative mx-auto inline-block w-max [filter:drop-shadow(0px_1px_3px_rgba(27,_37,_80,_0.14))]">
          <div
            className="absolute left-0 top-[1px] bg-clip-text bg-no-repeat text-transparent bg-gradient-to-r py-4 from-purple-500 via-violet-500 to-pink-500 [text-shadow:0_0_rgba(0,0,0,0.1)]">
            <span className="">That Launch Instantly</span>
          </div>
          <div
            className="relative bg-clip-text text-transparent bg-no-repeat bg-gradient-to-r from-purple-500 via-violet-500 to-pink-500 py-4">
            <span className="">That Launch Instantly</span>
          </div>

          <div>
            <p className="text-[20px] lg:text-[24px] max-w-2xl my-4 mx-auto text-neutral-500 text-center font-normal dark:text-neutral-300">
              Launch a Business in Minutes, Run it Like an Enterprise.
            </p>
            <p className="text-[18px] lg:text-[24px] max-w-2xl my-4 mx-auto text-neutral-500 text-center font-normal dark:text-neutral-300">
              One Platform | Zero Code | Infinite Growth
            </p>
          </div>

          <div
            initial={{
              opacity: 0,
            }}
            animate={{
              opacity: 1,
            }}
            transition={{
              duration: 0.3,
              delay: 1,
            }}
            className="relative z-10 mt-8 flex lg:mb-0 mb-5 flex-wrap items-center flex-col lg:flex-row justify-center gap-4"
          >
            <a href="/request-demo">
            <button className="w-60 transform rounded-lg bg-black px-6 py-2 text-white transition-all duration-300 hover:-translate-y-0.5 hover:bg-gray-800 dark:bg-white dark:text-black dark:hover:bg-gray-200" style={{ fontSize: "17px" }}>
              Book Demo
            </button>
            </a>
            <a href="/contact">
            <button className="w-60 transform rounded-lg border border-gray-300 bg-white px-6 py-2  text-black transition-all duration-300 hover:-translate-y-0.5 hover:bg-gray-100 dark:border-gray-700 dark:bg-black dark:text-white dark:hover:bg-gray-900" style={{ fontSize: "17px" }}>
              Contact Support
            </button>
            </a>
          </div>

        </div>
      </h2>
    </BackgroundBeamsWithCollision>
  );
}


const WhyZeroClick = () => (
  <section className="bg-gray-100 py-20 px-6">
    <div className="max-w-5xl mx-auto text-center">
      <div className='flex gap-2'>

        <div style={{ width: "45%" }}>
          <h2 className="text-4xl font-bold mb-4">What is 0Clik? </h2>
          <h5>“Click to Launch. AI to Scale.”</h5>
        </div>

        <div style={{ width: "55%", display: "flex", alignItems: "start", flexDirection: "column", gap: "10px" }}>
          <p style={{ textAlign: "start", fontSize: "18px", fontWeight: "400" }}>
            0Clik.com is an AI-powered website and app deployment engine for fast-moving D2C, retail, and brand-led businesses. You don’t need developers. You don’t need months. You just need a product idea, and 0Clik gets it live… intelligently, instantly.
          </p>

          {/* <h3 className="text-1xl">  0Clik Includes: </h3> */}

          <ul >
            <li className='flex'>
              <ArrowBigRight /> No-code store builder
            </li>
            <li className='flex'>
              <ArrowBigRight /> AI search & product recommendations

            </li>
            <li className='flex'>
              <ArrowBigRight /> Smart pricing & promotion automation

            </li>
            <li className='flex'>
              <ArrowBigRight /> Loyalty & rewards

            </li>
            <li className='flex'>
              <ArrowBigRight /> Chatbot for customer support + AI commerce
            </li>
            <li className='flex'>
              <ArrowBigRight /> Analytics & customer insights
            </li>
            <li className='flex'>
              <ArrowBigRight />  Omnichannel-ready: Web, Android, iOS, PWA
            </li>

          </ul>
        </div>
      </div>

    </div>
  </section>
);

const features = [
  { label: "Autocomplete & suggestion", passed: true },
  { label: "Personalized results", passed: true },
  { label: "Spelling correction & synonyms", passed: false },
  { label: "Real-time recommendations", passed: true },
  { label: "Content-based filtering", passed: true },
  // { label: "Content-based filtering", passed: true },
];

const WhyZeroClick2 = () => (
  <section className="bg-gray-100 lg:py-20 py-0 px-6">
    <div className=" mx-auto text-center">
      <div className='d-flex flex-column align-items-center'>

        <div >
          <h1 className="lg:text-6xl text-3xl font-bold mb-4">0Clik : Click to Launch. AI to Scale.</h1>
          {/* <h5>“Click to Launch. AI to Scale.”</h5> */}
        </div>

        <div style={{ display: "flex", alignItems: "center", flexDirection: "column", gap: "10px" }}>
          <p style={{ textAlign: "center", fontSize: "18px", fontWeight: "400", color: "grey" }}>
            0Clik.com is an AI-powered website and app deployment engine for fast-moving D2C, retail, and brand-led businesses
          </p>

          <div className="w-full flex justify-center flex-col lg:flex-row gap-4 mt-3">
            <span className='p-2 flex gap-2' style={{ color: "white", borderRadius: "20px", background: "black" }}>
              <CodeXml style={{ color: "red" }} />
              No Code
            </span>
            <span className="p-2 flex gap-2" style={{ color: "white", borderRadius: "20px", background: "black" }}>
              <ChartPie style={{ color: "yellow" }} />
              Powerful Analytics
            </span>
            <span className="p-2 flex gap-2" style={{ color: "white", borderRadius: "20px", background: "black" }}>
              <Bot style={{ color: "blue" }} />
              AI Search
            </span>
          </div>

          {/* <h3 className="text-1xl">  0Clik Includes: </h3> */}

          <ul className='hidden' >
            <li className='flex'>
              <ArrowBigRight /> No-code store builder
            </li>
            <li className='flex'>
              <ArrowBigRight /> AI search & product recommendations

            </li>
            <li className='flex'>
              <ArrowBigRight /> Smart pricing & promotion automation

            </li>
            <li className='flex'>
              <ArrowBigRight /> Loyalty & rewards

            </li>
            <li className='flex'>
              <ArrowBigRight /> Chatbot for customer support + AI commerce
            </li>
            <li className='flex'>
              <ArrowBigRight /> Analytics & customer insights
            </li>
            <li className='flex'>
              <ArrowBigRight />  Omnichannel-ready: Web, Android, iOS, PWA
            </li>

          </ul>
          <div className='flex flex-col lg:flex-row mt-3' style={{ background: "black", color: "white", borderRadius: "20px" }}>
            <div >
              <div style={{ borderBottom: "1px solid grey", padding: "20px" }}>

                <p style={{ fontSize: "20px", textAlign: "start" }}>
                  No-code store builder
                </p>
                <p style={{ textAlign: "start", fontSize: "12px", marginTop: "10px" }}>
                  No-code store builders let anyone launch and manage an online store using simple drag-and-drop tools—no coding skills needed.
                </p>

                <div>
                  <div className="voice-feature mt-3">
                    <Store className="voice-icon" style={{ color: "#00d084" }} />
                    <span>Easily create and manage your online store without writing a single line of code.</span>
                  </div>
                  <div className="voice-feature mt-3">
                    <DraftingCompass className="voice-icon" style={{ color: "#00d084" }} />
                    <span>Drag-and-drop tools and pre-built templates make launching fast and beginner-friendly.</span>
                  </div>
                </div>
              </div>

              <div  >
                <div className="voice-ai-container">

                  <p style={{ fontSize: "20px", textAlign: "start" }}>
                    Smart pricing & promotion automation
                  </p>
                  <p style={{ textAlign: "start", fontSize: "12px", marginTop: "10px" }}>
                    Build and deploy low cost voice AI agents <br />
                    that talk and take actions like humans
                  </p>

                  <div className="voice-feature mt-3">
                    <BadgeIndianRupee className="voice-icon" style={{ color: "#00d084" }} />
                    <span>Dynamic price adjustments based on demand, competition, and inventory.</span>
                  </div>
                  <div className="voice-feature">
                    <Bot className="voice-icon" style={{ color: "#00d084" }} />
                    <span>AI-driven discount strategies that maximize revenue and conversion.</span>
                  </div>
                  <div className="voice-feature">
                    <ChartPie className="voice-icon" style={{ color: "#00d084" }} />
                    <span>Real-time analytics to monitor promotion performance and ROI.</span>
                  </div>
                  <div className="voice-feature">
                    <CirclePercent className="voice-icon" style={{ color: "#00d084" }} />
                    <span>Personalized offers based on user behavior and segmentation.</span>
                  </div>
                </div>
              </div>



            </div>

            <div style={{ border: "1px solid grey" }}>
              <div style={{ borderBottom: "1px solid grey", padding: "20px" }}>
                <p style={{ fontSize: "20px", textAlign: "start" }}>
                  AI search & product recommendations
                </p>
                <p style={{ textAlign: "start", fontSize: "13px", marginTop: "10px" }}>
                  AI search and recommendations deliver smarter, personalized shopping experiences.


                </p>




                <div className='mt-3 flex justify-center' >

                  <div
                    style={{
                      backgroundColor: "#1c1c1c",
                      padding: "20px",
                      borderRadius: "12px",
                      width: "350px",
                      fontFamily: "sans-serif",
                      color: "white",
                    }}
                  >
                    {features.map((feature, index) => (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          backgroundColor: "#2c2c2c",
                          padding: "10px 15px",
                          borderRadius: "10px",
                          marginBottom: index !== features.length - 1 ? "10px" : "0",
                        }}
                      >
                        <span
                          style={{
                            color: "#00d084",
                            fontSize: "14px",
                            marginRight: "10px",
                          }}
                        >
                          <CircleCheckBig style={{ color: "#00d084", }} />
                        </span>
                        <p style={{ margin: 0, textAlign: "start" }}>{feature.label}</p>
                      </div>
                    ))}
                  </div>

                </div>

              </div>

              <div className='mt-3'>
                <div className="analytics-container">
                  <p style={{ fontSize: "20px", textAlign: "start" }}>Analytics & customer insights</p>
                  <p style={{ textAlign: "start", fontSize: "13px" }}>
                    Help businesses understand user behavior, optimize experiences, and make data-driven decisions for growth.
                  </p>
                  <div className="search-bar">
                    <Search className="search-icon" />
                    <span className="search-placeholder">Type your question</span>
                  </div>
                  <div className="suggestion-box">
                    Which issues frequently lead to escalations?
                  </div>
                </div>
              </div>
            </div>


            <div style={{ padding: "20px" }}>
              <p style={{ fontSize: "20px", textAlign: "start" }}>
                Chatbot for customer support + AI commerce

              </p>
              <p style={{ textAlign: "start", fontSize: "13px", marginTop: "10px" }}>
                AI-powered chatbots handle customer support and drive sales with real-time, personalized assistance.
              </p>

              <div>
                <div className="phone-frame">
                  <div className="chat-container">
                    <div className="bot-message">Hello, how can I assist you today?</div>
                    <div className="user-message">I received a spilled coffee.</div>
                    <div className="bot-message">Please upload an image of the spilled coffee so that I can assist you better.</div>
                    <div className="user-message with-avatar">
                      {/* <img src={spilledCoffee} alt="Spilled Coffee" className="avatar" /> */}
                      <span>hello</span>
                      <span>Sure, here it is.</span>
                    </div>
                    <div className="bot-message">Thanks for the image! I was able to verify the spillage. Would you like a replacement or refund?</div>
                    <div className="user-message">A replacement works for me.</div>
                    <div className="bot-message">Thanks for the confirmation! A replacement order has been placed for you.</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </section>
);

const Features = () => (
  <section className="py-16 lg:px-20 px-6">
    <div className="max-w-5xl mx-auto text-center">
      <h2 className='text-4xl font-bold'>AI: Your Built-In Growth Brain</h2>

      <p className='text-xl mt-2 '>
        Every module in 0Clik is AI-enhanced.
      </p>
    </div>

    <div class="grid grid-cols-1 sm:grid-cols-3 gap-8 lg:p-8 bg-white">
      <div class="flex flex-col items-center text-center space-y-2 shadow p-4 py-5 rounded-xl">
        <div class="p-3 rounded-full shadow-sm" style={{ border: "1px solid #3e3e3e3e" }}>
          <FaComments size={30} style={{ color: "#7453e0" }} />
        </div>
        <p class="text-md">Conversational Commerce</p>
        <p class="text-sm">Let customers buy directly from WhatsApp or chatbot-powered flows.
        </p>
      </div>
      <div class="flex flex-col items-center text-center space-y-2 shadow p-4 py-5 rounded-xl">
        <div class="p-3 rounded-full shadow-sm" style={{ border: "1px solid #3e3e3e3e" }}>
          <FaBullseye size={30} style={{ color: "#7453e0" }} />
        </div>
        <p class="text-md">Smart Recommendations & Personalization</p>
        <p class="text-sm">Dynamically adjust experiences based on behavior, intent, and past actions.
        </p>
      </div>
      <div class="flex flex-col items-center text-center space-y-2 shadow p-4 py-5 rounded-xl">
        <div class="p-3 rounded-full shadow-sm" style={{ border: "1px solid #3e3e3e3e" }}>
          <FaChartLine size={30} style={{ color: "#7453e0" }} />
        </div>
        <p class="text-md">Predictive Analytics</p>
        <p class="text-sm">See what your customer might want next before they even do.

        </p>
      </div>
      <div class="flex flex-col items-center text-center space-y-2 shadow p-4 py-5 rounded-xl">
        <div class="p-3 rounded-full shadow-sm" style={{ border: "1px solid #3e3e3e3e" }}>
          <FaCogs size={30} style={{ color: "#7453e0" }} />
        </div>
        <p class="text-md">AI Promotion Engine</p>
        <p class="text-sm">Automatically run the right offers for the right customer - no guesswork.
        </p>
      </div>
      <div class="flex flex-col items-center text-center space-y-2 shadow p-4 py-5 rounded-xl">
        <div class="p-3 rounded-full shadow-sm" style={{ border: "1px solid #3e3e3e3e" }}>
          <FaComments size={30} style={{ color: "#7453e0" }} />
        </div>
        <p class="text-md">Conversational Commerce</p>
        <p class="text-sm">Let customers buy directly from WhatsApp or chatbot-powered flows.
        </p>
      </div>
      <div class="flex flex-col items-center text-center space-y-2 shadow p-4 py-5 rounded-xl">
        <div class="p-3 rounded-full shadow-sm" style={{ border: "1px solid #3e3e3e3e" }}>
          <FaComments size={30} style={{ color: "#7453e0" }} />
        </div>
        <p class="text-md">Conversational Commerce</p>
        <p class="text-sm">Let customers buy directly from WhatsApp or chatbot-powered flows.
        </p>
      </div>
    </div>
  </section>
);

const Ui = () => (
  <section className="py-6 hidden">
    {/* <div className='text-center pb-5'>
      <h2 className='text-4xl text-black font-bold'>
        Who is 0Clik For?
      </h2>
    </div> */}
    <div class="flex justify-center items-center bg-cover bg-center pb-20 text-white">
      {/* <div>
          <h2 className='text-4xl text-black font-bold pt-4'>
            Who is 0Clik For?
          </h2>
        </div> */}
      <div class="flex flex-wrap gap-6 w-full justify-center forMob rounded-xl px-2">
        <div>
          <h2 className='text-4xl text-black font-bold pt-4'>
            Who is 0Clik For?
          </h2>
        </div>
        <div className="flex flex-row items-start space-x-6">
          <div class="w-full sm:w-100 p-6 text-center transform cursor-pointer transition-transform hover:-translate-y-1">
            <div class="text-4xl mb-4 flex justify-center"> <FaStore style={{ color: "gray" }} /> </div>
            <h3 class="text-xl font-bold mb-2 text-black">D2C Startups</h3>
            <p class="text-sm text-black">Launch a site & app, use AI to drive conversion.</p>
          </div>
          <div class="h-40 self-center" style={{ border: "1px solid #3e3e3e3e" }}></div>

          <div class="w-full sm:w-100 p-6 cursor-pointer text-center transform transition-transform hover:-translate-y-1">
            <div class="text-4xl mb-4 flex justify-center"> <FaTag style={{ color: "gray" }} /> </div>
            <h3 class="text-xl font-bold mb-2 text-black">Lifestyle Brands</h3>
            <p class="text-sm text-black">Personalized discovery + loyalty engagement.</p>
          </div>

          <div class="h-40 self-center" style={{ border: "1px solid #3e3e3e3e" }}></div>
          <div class="w-full sm:w-100 cursor-pointer p-6 text-center transform transition-transform hover:-translate-y-1">
            <div class="text-4xl mb-4 flex justify-center">  <FaBullhorn style={{ color: "gray" }} /></div>
            <h3 class="text-xl font-bold mb-2 text-black">Digital Marketers</h3>
            <p class="text-sm text-black">Promotion engine + segmentation for growth.</p>
          </div>
          <div class="h-40 w-30 self-center" style={{ border: "1px solid #3e3e3e3e" }}></div>
          <div class="w-full sm:w-100 p-6 cursor-pointer text-center transform transition-transform hover:-translate-y-1">
            <div class="text-4xl mb-4 flex justify-center"> <FaHandshake style={{ color: "gray" }} /></div>
            <h3 class="text-xl font-bold text-black mb-2">Agencies</h3>
            <p class="text-sm text-black">Whitelabel and deploy storefronts for clients.</p>
          </div>
          <div class="h-40 self-center" style={{ border: "1px solid #3e3e3e3e" }}></div>
          <div class="w-full sm:w-100 cursor-pointer p-6 text-center transform transition-transform hover:-translate-y-1">
            <div class="text-4xl mb-4 flex justify-center"> <FaShoppingCart style={{ color: "gray" }} /> </div>
            <h3 class="text-xl font-bold mb-2 text-black">Omni-channel Retail</h3>
            <p class="text-sm text-black">AI chatbot + pricing across platforms.</p>
          </div>
        </div>
      </div>
    </div>

  </section>
);

const ARShowcase = () => (
  <section className="bg-gray-100 py-20 px-6">
    <div className="max-w-5xl mx-auto text-center">
      <h2 className="text-4xl font-bold mb-12">Architecture - Engineered for Agility & Scale
      </h2>
      {/* <p className="text-lg mb-10 max-w-2xl mx-auto">Experience immersive shopping with:</p> */}
      <ul className="grid grid-cols-1 sm:grid-cols-2 gap-10 text-lg">
        <li className="flex items-center justify-start"><Glasses className="mr-3 text-blue-600 h-6 w-6" />Multi-Tenant Core:Scale across geographies, clients, or franchises</li>
        <li className="flex items-center justify-start"><Rotate3D className="mr-3 text-blue-600 h-6 w-6" /> Real-time 3D visualization</li>
        <li className="flex items-center justify-start"><Search className="mr-3 text-blue-600 h-6 w-6" /> Size & fit suggestions</li>
        <li className="flex items-center justify-start"><Paintbrush className="mr-3 text-blue-600 h-6 w-6" /> Color & style customization</li>
      </ul>
    </div>
  </section>
);

const architectureLayers = [
  {
    layer: 'Multi-Tenant Core',
    function: 'Easily scale your operations across geographies, clients, and franchises with a unified core.',
    icon: <Globe />,
  },
  {
    layer: 'Modular Microservices',
    function: 'Each component is designed to be plug-and-play for seamless integration and flexibility.',
    icon: <Microchip />,
  },
  {
    layer: 'AI Fabric',
    function: 'A unified decisioning layer powers all modules for consistent, intelligent operations.',
    icon: <Bot />,
  },
  {
    layer: 'Secure by Design',
    function: 'Built with encryption, compliance readiness, and audit-friendly architecture at its core.',
    icon: <ShieldOff />,
  },
  {
    layer: 'API-First',
    function: 'Seamlessly integrates with your CRM, payment systems, and analytics tools.',
    icon: '🔗',
  },
];

const TableUI = () => (
  <section className="architecture-section">
    <div className="bg-neutral-950 relative flex flex-col items-center justify-center antialiased">
      <div className="lg:p-12 p-6">
        <h2 style={{ fontWeight: "700" }}>Architecture – Engineered for Agility & Scale</h2>
        <div className="architecture-grid">
          {architectureLayers.map((item, i) => (
            <div key={i} className="architecture-card">
              <div className="icon">{item.icon}</div>
              <div>
                <h3>{item.layer}</h3>
                <p>{item.function}</p>
              </div>

            </div>
          ))}
          {/* <BackgroundBeams /> */}
        </div>
      </div>
      <BackgroundBeams />
    </div>
  </section>
)

const words = " AI-Native Website & App Stack for Digital-First Brands, Aspiring Enterprises, and E-Commerce Marketplaces0Clik is a one-click, no-code platform to build, deploy, and run an intelligent digital commerce experience with Gen-AI chatbot, Gen-AI search, recommendation engine, innovative pricing, and more."

const MarketPlace = () => (
  <section className="py-16 bg-white text-[#301407] lg:px-16 px-1">
    <h2 className='text-4xl font-bold mb-12 text-center'>Why 0Clik?</h2>
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row md:items-start gap-12">
      <div className="md:w-1/2">
        <h2 className="lg:text-3xl text-2xl lg:text-left text-center font-bold leading-tight mb-4">Built for Scale, Powered by Intelligence.</h2>
        <p className="text-gray-700 mb-6 mt-2">
          Powered by Fixall.AI | No developers needed | End-to-end stack | Plug & play modules
        </p>
        <TextGenerateEffect duration={2} filter={false} words={words} />
        <div className="flex space-x-6 mt-3">
          <button className="bg-[#7453E0] text-sm text-white font-semibold  px-4 py-2 rounded">Schedule a Live Demo</button>
        </div>
      </div>

      <div className="w-px bg-gray-300 hidden md:block"></div>

      <div className="md:w-1/2 grid grid-cols-1 gap-4">
        <div className="flex space-x-4">
          <div className="text-3xl" style={{color: "rgb(116, 83, 224)"}}>
            <IoRocketSharp />
          </div>
          <div>
            <h4 className="font-semibold text-lg">Want to launch fast</h4>
            <p className="text-gray-600">
              <TextGenerateEffect duration={3} filter={false} words=" Just Drag & Drop using the Storefront Builder" />
            </p>
          </div>
        </div>
        <div className="border-t border-gray-300" />

        <div className="flex space-x-4">
          <div className="text-3xl" style={{color: "rgb(116, 83, 224)"}}>
            <FaSearch />
          </div>
          <div>
            <h4 className="font-semibold text-lg">Want AI discovery</h4>
            <p className="text-gray-600">
              <TextGenerateEffect duration={3} filter={false} words="Gen-AI Smart Search & Product Recommendations can help you find exactly what you need." />
            </p>
          </div>
        </div>
        <div className="border-t border-gray-300" />

        <div className="flex space-x-4">
          <div className="text-3xl" style={{color: "rgb(116, 83, 224)"}}>
            <FaChartLine />
          </div>
          <div>
            <h4 className="font-semibold text-lg">Want to automate growth</h4>
            <p className="text-gray-600">
              <TextGenerateEffect duration={3} filter={false} words="Our Promotion & Pricing Engine helps you optimize strategies effortlessly." />
            </p>
          </div>
        </div>
        <div className="border-t border-gray-300" />

        <div className="flex space-x-4">
          <div className="text-3xl" style={{color: "rgb(116, 83, 224)"}}>
            <FaTools />
          </div>
          <div>
            <h4 className="font-semibold text-lg">Want better service</h4>
            <p className="text-gray-600">
              Our AI-powered Chatbot for Customer Care & AI-assisted Commerce ensures seamless customer interactions.
            </p>
          </div>
        </div>
        <div className="border-t border-gray-300" />

        <div className="flex space-x-4">
          <div className="text-3xl" style={{color: "rgb(116, 83, 224)"}}>
            <FaChartPie />
          </div>
          <div>
            <h4 className="font-semibold text-lg">Want insights</h4>
            <p className="text-gray-600">
              <TextGenerateEffect duration={3} filter={false} words="  Gain a complete view with built-in dashboards and a 360° customer profile." />


            </p>
          </div>
        </div>

        <div className="border-t border-gray-300" />

        <div className="flex space-x-4">
          <div className="text-3xl" style={{color: "rgb(116, 83, 224)"}}>
            <FaGlobe />
          </div>
          <div>
            <h4 className="font-semibold text-lg">Want to sell everywhere</h4>
            <p className="text-gray-600">

              <TextGenerateEffect duration={3} filter={false} words="Our platform is Web, Mobile App, and PWA ready for seamless multi-channel selling." />

            </p>
          </div>
        </div>

      </div>
    </div>
  </section>
);


const modules = [
  {
    icon: '👗',
    title: 'Virtual Try-Ons',
    description: [
      '✓ AI-powered robust try-on engine',
      '✓ 93.9% uptime with infinite scalability',
      '✓ Industry-leading conversion in Beauty',
    ],
    badge: '+42% engagement',
    color: '#FF6B6B',
  },

  {
    icon: '🤖',
    title: 'AI Chatbot',
    description: [
      '✓ NLP-based customer support',
      '✓ 24/7 WhatsApp & Web integration',
      '✓ Conversational product discovery',
    ],
    color: '#FFBE0B',
  },
  {
    icon: '🛒',
    title: 'Gen-AI Search & Recommendations',
    description: [
      '✓ Typo-tolerant semantic search',
      '✓ Context-aware cross-selling',
      '✓ AI bundles and look-alike products',
    ],
    color: '#8338EC',
  },
];


const modules2 = [
  {
    icon: '👗',
    title: 'Store Builder',
    description: [
      '✓ Drag & Drop components',
      '✓ 20+ responsive themes',
      '✓ Custom domain & hosting included',
      '✓ Auto-deploy to Android, iOS, and PWA',
    ],
    // badge: '+42% engagement',
    color: '#FF6B6B',
  },
  {
    icon: '💰',
    title: 'Loyalty & Rewards',
    description: [
      '✓ Points-based loyalty engine',
      '✓ Referral rewards, gamified incentives',
      '✓ CRM tagging and reward-based segmentation',
    ],
    color: '#4ECDC4',
  },

  {
    icon: '🛒',
    title: 'Analytics & Customer 360°',
    description: [
      '✓ Real-time dashboards',
      '✓ Conversion funnel tracking',
      '✓ Cohort analysis',
      '✓ Predictive customer lifetime value',
    ],
    color: '#8338EC',
  },
  {
    icon: '💰',
    title: 'Promotion & Pricing Engine',
    description: [
      '✓ Dynamic pricing rules',
      '✓ Campaigns: flat, volume, bundle',
      '✓ Scheduled automation + A/B testing',
    ],
    color: '#4ECDC4',
  },
];

const CoreModulesCapabilities = () => (
  <section className=" p-5" >
    <div className="core-container" style={{ borderRadius: "20px" }}>
      <div className="core-left">
        <p style={{ fontSize: "25px" }}>Core Modules & Capabilities</p>
        <p className="subtitle">
          AI-powered commerce solutions driving growth and engagement
        </p>

        <div className="modules-list">
          {modules.map((mod, i) => (
            <div
              key={i}
              className="module-box"
              style={{ borderLeft: `1px solid ${mod.color}`, border: `1px solid ${mod.color}` }}
            >
              {/* <div className="module-icon">{mod.icon}</div> */}
              <div>
                <h3>{mod.title}</h3>
                <ul>
                  {mod.description.map((item, j) => (
                    <li key={j}>{item}</li>
                  ))}
                </ul>
                {mod.badge && <span className="badge">{mod.badge}</span>}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="core-left">
        <div className="modules-list">
          {modules2.map((mod, i) => (
            <div
              key={i}
              className="module-box"
              style={{ border: `1px solid ${mod.color}` }}
            >
              {/* <div className="module-icon">{mod.icon}</div> */}
              <div>
                <h3>{mod.title}</h3>
                <ul>
                  {mod.description.map((item, j) => (
                    <li key={j}>{item}</li>
                  ))}
                </ul>
                {mod.badge && <span className="badge">{mod.badge}</span>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

const Personalization = () => (
  <section className="py-20 px-6">
    <div className="max-w-5xl mx-auto text-center">
      <h2 className="text-4xl font-bold mb-12">Smart Personalization</h2>
      <ul className="grid grid-cols-1 sm:grid-cols-2 gap-10 text-lg">
        <li className="flex items-center justify-start"><User className="mr-3 text-blue-600 h-6 w-6" /> Location-based curation</li>
        <li className="flex items-center justify-start"><Tag className="mr-3 text-blue-600 h-6 w-6" /> Dynamic collections</li>
        <li className="flex items-center justify-start"><Search className="mr-3 text-blue-600 h-6 w-6" /> Personalized shopping feed</li>
      </ul>
    </div>
  </section>
);

const ONDCIntegration = () => (
  <section className="bg-blue-50 py-20 px-6">
    <div className="max-w-5xl mx-auto text-center">
      <h2 className="text-4xl font-bold mb-12">ONDC Integration</h2>
      <ul className="grid grid-cols-1 sm:grid-cols-2 gap-10 text-lg">
        <li className="flex items-center justify-start"><ShoppingCart className="mr-3 text-blue-600 h-6 w-6" /> ONDC protocol compliant</li>
        <li className="flex items-center justify-start"><Search className="mr-3 text-blue-600 h-6 w-6" /> Unified cart & discovery</li>
        <li className="flex items-center justify-start"><Tag className="mr-3 text-blue-600 h-6 w-6" /> Standard checkout</li>
        <li className="flex items-center justify-start"><User className="mr-3 text-blue-600 h-6 w-6" /> Multi-category access</li>
      </ul>
    </div>
  </section>
);

const CrossDevice = () => (
  <section className="py-20 px-6">
    <div className="max-w-5xl mx-auto text-center">
      <h2 className="text-4xl font-bold mb-12">Cross-Device Experience</h2>
      <p className="text-lg mb-10 max-w-2xl mx-auto">Seamless performance across:</p>
      <ul className="grid grid-cols-1 sm:grid-cols-3 gap-10 text-lg">
        <li className="flex items-center justify-center"><Smartphone className="mr-3 text-blue-600 h-6 w-6" /> Smartphones</li>
        <li className="flex items-center justify-center"><Monitor className="mr-3 text-blue-600 h-6 w-6" /> Desktops</li>
        <li className="flex items-center justify-center"><Tablet className="mr-3 text-blue-600 h-6 w-6" /> Tablets</li>
      </ul>
      <p className="mt-10 text-gray-600 text-lg">No downloads or logins required.</p>
    </div>
  </section>
);

const Benefits = () => (
  <section className="bg-gray-100 py-20 px-6">
    <div className="max-w-5xl mx-auto text-center">
      <h2 className="text-4xl font-bold mb-12">Benefits for Everyone</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h3 className="font-bold text-blue-600 text-xl mb-2">Consumers</h3>
          <p className="text-gray-700">Immersive shopping experience</p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h3 className="font-bold text-blue-600 text-xl mb-2">Sellers</h3>
          <p className="text-gray-700">Increased visibility</p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h3 className="font-bold text-blue-600 text-xl mb-2">ONDC</h3>
          <p className="text-gray-700">Full-stack capabilities</p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h3 className="font-bold text-blue-600 text-xl mb-2">Policy</h3>
          <p className="text-gray-700">Decentralized commerce</p>
        </div>
      </div>
    </div>
  </section>
);

const UseCases = () => (
  <section className="py-20 px-6">
    <div className="max-w-5xl mx-auto text-center">
      <h2 className="text-4xl font-bold mb-12">Use Cases</h2>
      <ul className="grid grid-cols-1 sm:grid-cols-2 gap-10 text-lg">
        <li className="flex items-center justify-start"><ShoppingCart className="mr-3 text-blue-600 h-6 w-6" /> Fashion brand engagement</li>
        <li className="flex items-center justify-start"><Tag className="mr-3 text-blue-600 h-6 w-6" /> Regional seller reach</li>
        <li className="flex items-center justify-start"><Search className="mr-3 text-blue-600 h-6 w-6" /> White-label solutions</li>
        <li className="flex items-center justify-start"><User className="mr-3 text-blue-600 h-6 w-6" /> Enterprise reference</li>
      </ul>
    </div>
  </section>
);

const RequestDemo = () => (
  <section className="bg-gradient-to-br from-blue-600 to-indigo-700 text-white py-20 px-6">
    <div className="max-w-5xl mx-auto text-center">
      {/* <h2 className="text-4xl font-bold mb-6">Request a Demo</h2>
      <p className="text-lg mb-10 max-w-2xl mx-auto">
        See 0zlick in action! Fill out the form below, and our team will get in touch with you.
      </p>
      <form className="max-w-xl mx-auto space-y-6">
        <div>
          <input
            type="text"
            placeholder="Your Name"
            className="w-full px-4 py-3 rounded-lg text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-300"
            required
          />
        </div>
        <div>
          <input
            type="email"
            placeholder="Your Email"
            className="w-full px-4 py-3 rounded-lg text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-300"
            required
          />
        </div>
        <div>
          <textarea
            placeholder="Your Message (Optional)"
            className="w-full px-4 py-3 rounded-lg text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-300 h-32"
          />
        </div>

        <Link to="/request-demo">
        <button
          type="submit"
          className="inline-flex items-center px-8 py-4 bg-white text-blue-600 font-semibold rounded-full shadow-lg hover:bg-gray-100 transition duration-300 text-lg"
        >
          <Rocket className="mr-2 h-6 w-6" /> Submit Request
        </button>
        </Link>
        
      </form> */}
      <Link to="/request-demo">
        <button
          type="submit"
          className="inline-flex items-center px-8 py-4 bg-white text-blue-600 font-semibold rounded-full shadow-lg hover:bg-gray-100 transition duration-300 text-lg"
        >
          <Rocket className="mr-2 h-6 w-6" />Request a Demo
        </button>
      </Link>
    </div>
  </section>
);